import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

import CloseIcon from "@atlaskit/icon/glyph/editor/close";
import SearchIcon from "@atlaskit/icon/glyph/editor/search";

import styled from "styled-components";
import Spinner from "@atlaskit/spinner";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { CloseButton } from "./SidebarIconPicker/styled/Components";
import { TextField } from "../../Styled/atlaskitComponents";
import { ConfigButton } from "../../../cards-v2/components/editor/styled";
import { useTheme } from "styled-components";
import { CardsMacroContext } from "../../../cards-v2/Context";
import {
  styleguidePropertyKeys,
  styleguideService,
} from "../../Service/StyleguideService";

const AppIconWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 15px;
`;

const SpinnerContainer = styled.div`
  text-align: center;
  padding-top: 25px;
`;

const AppIconPreview = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 0.25rem;
  padding: 10px;
  border-radius: 10px;
  transition: transform 0.1s ease-in, background 0.1s ease-in;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    transform: scale(0.95);
    cursor: pointer;
  }

  ${({ isSelected }) => {
    if (isSelected) {
      return "background: #DEEBFF !important";
    }
  }}
`;

const AppIcon = styled.div`
  img {
    height: 32px;
  }
`;

const AppIconTitle = styled.div`
  font-size: 11px;
  font-family: "PP Formula";
`;

function SidebarAppPicker({ appIcon, onIconSelect }) {
  const [appIcons, setAppIcons] = useState([]);

  useEffect(() => {
    styleguideService
      .getProperty(styleguidePropertyKeys.APP_ICONS)
      .then((response) => response && setAppIcons(response.data || []))
      .catch((e) => console.log(e));
  }, []);

  const { setUploadLogoDrawerOpen, userInStyleguidePermission } =
    useContext(CardsMacroContext);

  const [searchValue, setSearchValue] = useState(window.searchTerm || "");
  const theme = useTheme();

  return (
    <>
      <TextField
        placeholder="Search"
        value={searchValue}
        elemAfterInput={
          searchValue ? (
            <CloseButton onClick={() => setSearchValue("")}>
              <CloseIcon />
            </CloseButton>
          ) : (
            <SearchIcon size="large" />
          )
        }
        bg={theme.shared.sidebar.imagePicker.input}
        onChange={(e) => setSearchValue(e.target.value)}
      />

      {/* {userInStyleguidePermission && (
        <ConfigButton
          onClick={() => setUploadLogoDrawerOpen(true)}
          {...theme.shared.button.create}
          style={{ marginTop: "15px" }}
        >
          <EditorAddIcon />
          Add new Logos
        </ConfigButton>
      )} */}

      {!appIcons.length ? (
        <SpinnerContainer>
          <Spinner size="large" />
        </SpinnerContainer>
      ) : (
        <AppIconWrapper>
          {appIcons
            .filter((icon) =>
              searchValue
                ? icon.title.toLowerCase().includes(searchValue.toLowerCase())
                : true
            )
            .map((icon) => (
              <AppIconPreview
                isSelected={appIcon === icon.path}
                onClick={() => onIconSelect(icon)}
                key={icon.id}
              >
                <AppIcon>
                  <img src={icon.path} alt={icon.title} />
                </AppIcon>
                <AppIconTitle>{icon.title}</AppIconTitle>
              </AppIconPreview>
            ))}
        </AppIconWrapper>
      )}
    </>
  );
}

SidebarAppPicker.defaultProps = {
  appIcon: null,
};

SidebarAppPicker.propTypes = {
  onIconSelect: PropTypes.func.isRequired,
  appIcon: PropTypes.string,
};

export default SidebarAppPicker;
